
import React from 'react';
import { Search, Filter } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuLabel, 
  DropdownMenuSeparator, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";

interface UserFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  filterType: string | null;
  setFilterType: (type: string | null) => void;
  filterVerified: boolean | null;
  setFilterVerified: (verified: boolean | null) => void;
}

export const UserFilters: React.FC<UserFiltersProps> = ({
  searchQuery,
  setSearchQuery,
  filterType,
  setFilterType,
  filterVerified,
  setFilterVerified
}) => {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center justify-between mb-4">
      <div className="relative w-full md:w-72">
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Rechercher un utilisateur..."
          className="pl-8"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      
      <div className="flex flex-wrap items-center gap-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="flex items-center gap-1">
              <Filter className="h-4 w-4" /> Filtrer
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              Type d'utilisateur
            </DropdownMenuLabel>
            <DropdownMenuItem onClick={() => setFilterType(null)}>
              Tous
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType('user')}>
              Utilisateur
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterType('professional')}>
              Professionnel
            </DropdownMenuItem>
            
            <DropdownMenuSeparator />
            
            <DropdownMenuLabel>
              Statut de vérification
            </DropdownMenuLabel>
            <DropdownMenuItem onClick={() => setFilterVerified(null)}>
              Tous
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterVerified(true)}>
              Vérifiés
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setFilterVerified(false)}>
              Non vérifiés
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        
        {filterType && (
          <Badge variant="outline" className="gap-1 px-2 py-1">
            Type: {filterType === 'professional' ? 'Professionnel' : 'Utilisateur'}
            <Button
              variant="ghost"
              size="xs"
              className="h-4 w-4 p-0 ml-1"
              onClick={() => setFilterType(null)}
            >
              ×
            </Button>
          </Badge>
        )}
        
        {filterVerified !== null && (
          <Badge variant="outline" className="gap-1 px-2 py-1">
            {filterVerified ? 'Vérifiés' : 'Non vérifiés'}
            <Button
              variant="ghost"
              size="xs"
              className="h-4 w-4 p-0 ml-1"
              onClick={() => setFilterVerified(null)}
            >
              ×
            </Button>
          </Badge>
        )}
      </div>
    </div>
  );
};
